import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FloatingSubmenuCoordinatorService {
  private readonly activeSubmenu$ = new BehaviorSubject<string | null>(null);

  constructor(private router: Router) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.closeAll();
    });
  }

  open(submenuId: string): void {
    this.activeSubmenu$.next(submenuId);
  }

  closeAll(): void {
    this.activeSubmenu$.next(null);
  }

  watchActiveSubmenu(): Observable<string | null> {
    return this.activeSubmenu$.asObservable().pipe(distinctUntilChanged());
  }
}
